export const General = () => {
    return (
        <div>
            <h1>General</h1>
        </div>
    );
};
